import { render } from "./page-baca.vue?vue&type=template&id=02b91499&scoped=true"
import script from "./page-baca.vue?vue&type=script&lang=js"
export * from "./page-baca.vue?vue&type=script&lang=js"

import "./page-baca.vue?vue&type=style&index=0&id=02b91499&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02b91499"]])

export default __exports__